"use strict";

module.exports = require("../fine-uploader/fine-uploader");



//////////////////
// WEBPACK FOOTER
// ./node_modules/_fine-uploader@5.16.2@fine-uploader/lib/traditional.js
// module id = 9
// module chunks = 0